import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import instance from "../../../config/Config"

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
}
export const getAllUsers = createAsyncThunk(
    "getAllUsers",
    async (body, { rejectWithValue }) => {
        try {
            const response = await instance.get(`/hummingbird/user/get-user-list?page=${body.page}&search=${body.search}`);
            return response.data;

        }
        catch (error) {
            return rejectWithValue(error?.response)
        }
    }
)

export const AllUserSlice = createSlice({
    name: 'AllUserSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getAllUsers.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getAllUsers.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action?.payload
            state.count = action?.payload?.count;
        })
        builder.addCase(getAllUsers.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });
    },

})

export default AllUserSlice.reducer;